import styled from 'styled-components'
import FilterBar from 'projects/filter/filter-bar'
import SearchBar from 'projects/filter/search-bar'
import FilterTags from 'projects/filter/filter-tags'
import filters from './student-filters.json'

const StudentProjectsFilter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-block-end: 24px;
  gap: 16px;
  flex-wrap: wrap;
`

function StudentProjects() {
  return (
    <>
      <StudentProjectsFilter>
        <SearchBar />
        <FilterBar filters={filters} />
      </StudentProjectsFilter>
      <FilterTags filters={filters} />
    </>
  )
}

export default StudentProjects
